import React, { useState, useEffect } from "react";
import ActiveTabContext from "./ActiveTabContext";
import Header from "./Header";
import Hero from "./Hero";
import Stats from "./Stats";
import About from "./About";
import Skills from "./Skills";
import Portfolio from "./Portfolio";
import Contact from "./Contact";
import Footer from "./Footer";
import GoTop from "./GoTop";
import Geo from "./geo";
import { initGA } from "./GoogleAnalytics"; // Import the Google Analytics initializer
import FirebaseAuthenticator from "./FirebaseAuthenticator";

import PortfolioItem from "./PortfolioItem";
import { Route, Routes, useLocation, Navigate } from "react-router-dom";
import "./style.css";
import FilteredPortfolio from "./FilteredPortfolio";
import labelsData from "./labels.json"; // Import the labels data

const App = () => {
  const [scrollY, setScrollY] = useState(0);
  const location = useLocation();

  const [activeTabIndex, setActiveTabIndex] = useState(0);

  const moveLineToTab = (index) => {
    setActiveTabIndex(index);
  };

  useEffect(() => {
    initGA(); // Initialize Google Analytics when the app loads
  }, []);

  // Fetch unique templates from the JSON file
  const unique_templates = Array.from(
    new Set(labelsData.map((item) => item.template))
  );

  // Prevent right-click context menu
  useEffect(() => {
    const preventContextMenu = (e) => {
      e.preventDefault();
    };
    window.addEventListener("contextmenu", preventContextMenu);

    return () => {
      window.removeEventListener("contextmenu", preventContextMenu);
    };
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
    if (location.hash) {
      setTimeout(() => {
        const element = document.querySelector(location.hash);
        if (element) element.scrollIntoView();
      }, 0);
    }
  }, [location]);

  useEffect(() => {
    const savedTheme = localStorage.getItem("theme");
    const themeToApply = savedTheme || "dark_theme";
    document.body.classList.add(themeToApply);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div>
      <ActiveTabContext.Provider value={{ moveLineToTab }}>
        <Header isSticky={scrollY >= 10} activeTab={activeTabIndex} />
        <main>
          <div className="container">
            <Routes>
              {/* Added this new Route for tags */}
              <Route path="/portfolio/tags/:tag" element={<Portfolio />} />

              <Route
                path="/portfolio/:template"
                element={
                  unique_templates.includes(location.pathname.split("/")[2]) ? (
                    <FilteredPortfolio />
                  ) : (
                    <Navigate to="/404" />
                  )
                }
              />
              <Route
                path="/"
                element={
                  <>
                    <Hero />
                    <Stats />
                    <About />
                    <Skills />
                    <Portfolio />
                    <Contact />
                  </>
                }
              />
              <Route path="/portfolio" element={<Portfolio />} />
              <Route
                path="/portfolio/:template/:slug"
                element={<PortfolioItem />}
              />
              <Route
                path="/geo"
                element={
                  <FirebaseAuthenticator>
                    <Geo />
                  </FirebaseAuthenticator>
                }
              />
            </Routes>
          </div>
        </main>
        <Footer />
        {scrollY >= 10 && <GoTop />}
      </ActiveTabContext.Provider>
    </div>
  );
};

export default App;
